/*
  Code below is based on AceMetrix jQuery.deparam:
  https://github.com/AceMetrix/jquery-deparam/blob/master/jquery-deparam.js

  Not using any jQuery related parts and just the main code that does conversion
 */
'use strict';
// Security: these key parts would let a crafted URL write to Object.prototype.
const UNSAFE_KEYS = ['__proto__', 'constructor', 'prototype']

const QueryToJson = (params, coerce) => {
  let obj = {},
    coerceTypes = { 'true': !0, 'false': !1, 'null': null }

  // If params is an empty string or otherwise falsy, return obj.
  if (!params) {
    return obj
  }

  // Iterate over all name=value pairs.
  params.replace(/\+/g, ' ').split('&').forEach(function(v){
    let param = v.split( '=' ),
        key,
        val,
        cur = obj,
        i = 0;

    // Try to decode the key parameter safely
    try {
      key = decodeURIComponent(param[0]);
    } catch (e) {
      if (typeof window !== 'undefined'
        && window.Sentry
        && window.Sentry.captureException
      ) {
        window.Sentry.captureException(new Error('Query parameter key decoding failed'), {
          tags: {
            error_type: 'url_decode_failure',
            component: 'query_to_json_util',
            param_type: 'key'
          },
          extra: {
            original_key: param[0],
            full_param: v,
            params_string: params,
            error_message: e.message,
            stack_trace: e.stack,
            timestamp: new Date().toISOString(),
            page_url: typeof window !== 'undefined' ? window.location.href : 'unknown'
          },
          level: 'warning'
        })
      }
      key = param[0];
    }

    // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
    // into its component parts.
    var keys = key.split( '][' ),
    keysLast = keys.length - 1

    // If the first keys part contains [ and the last ends with ], then []
    // are correctly balanced.
    if ( /\[/.test( keys[0] ) && /\]$/.test( keys[ keysLast ] ) ) {
      // Remove the trailing ] from the last keys part.
      keys[ keysLast ] = keys[ keysLast ].replace( /\]$/, '' );

      // Split first keys part into two parts on the [ and add them back onto
      // the beginning of the keys array.
      keys = keys.shift().split('[').concat( keys );

      keysLast = keys.length - 1;
    } else {
      // Basic 'foo' style key.
      keysLast = 0
    }

    if ( keys.some(part => UNSAFE_KEYS.includes(part)) ) {
      return
    }

    // Are we dealing with a name=value pair, or just a name?
    if ( param.length === 2 ) {
      try {
        val = decodeURIComponent( param[1] );
      } catch (e) {
        if (typeof window !== 'undefined'
          && window.Sentry
          && window.Sentry.captureException
        ) {
          window.Sentry.captureException(new Error('Query parameter value decoding failed'), {
            tags: {
              error_type: 'url_decode_failure',
              component: 'query_to_json_util',
              param_type: 'value'
            },
            extra: {
              original_value: param[1],
              decoded_key: key,
              full_param: v,
              params_string: params,
              error_message: e.message,
              stack_trace: e.stack,
              timestamp: new Date().toISOString(),
              page_url: typeof window !== 'undefined' ? window.location.href : 'unknown'
            },
            level: 'warning'
          })
        }
        val = param[1];
      }

      // Coerce values.
      if ( coerce ) {
        val = val && !isNaN(val) && ((+val + '') === val) ? +val        // number
          : val === 'undefined'                       ? undefined         // undefined
            : coerceTypes[val] !== undefined           ? coerceTypes[val] // true, false, null
              : val                                                           // string
      }

      if ( keysLast ) {
        // Complex key, build deep object structure based on a few rules:
        // * The 'cur' pointer starts at the object top-level.
        // * [] = array push (n is set to array length), [n] = array if n is
        //   numeric, otherwise object.
        // * If at the last keys part, set the value.
        // * For each keys part, if the current level is undefined create an
        //   object or array based on the type of the next keys part.
        // * Move the 'cur' pointer to the next level.
        // * Rinse & repeat.
        for ( ; i <= keysLast; i++ ) {
          // Arrays only accept push ([]) or index keys; anything else (e.g. `length`) would throw.
          if ( Array.isArray(cur) && keys[i] !== '' && !/^\d+$/.test(keys[i]) ) {
            return
          }
          key = keys[i] === '' ? cur.length : keys[i];
          const existing = Object.prototype.hasOwnProperty.call(cur, key) ? cur[key] : undefined
          const nestable = typeof existing === 'object' && existing !== null
          cur = cur[key] = i < keysLast ? ( nestable ? existing : ( keys[i+1] && isNaN( keys[i+1] ) ? {} : [] ) ) : val
        }

      } else {
        // Simple key, even simpler rules, since only scalars and shallow
        // arrays are allowed.

        if ( Object.prototype.toString.call( obj[key] ) === '[object Array]' ) {
          // val is already an array, so push on the next value.
          obj[key].push( val )

        } else if ( {}.hasOwnProperty.call(obj, key) ) {
          // val isn't an array, but since a second value has been specified,
          // convert val into an array.
          obj[key] = [ obj[key], val ]

        } else {
          // val is a scalar.
          obj[key] = val
        }
      }

    } else if ( key ) {
      // No value was defined, so set something meaningful.
      obj[key] = coerce ? undefined : ''
    }
  })

  return obj
}

export default QueryToJson
